import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Instrument_Report_Filter from "./instrument_report_filter/Instrument_Report_Filter";
import Instrument_Report_Table from "./instrument_report_table/Instrument_Report_Table";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";

const Instrument_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report Instrument_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Instrument Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Instrument_Report_Filter setShow={setShow}/>
      </div>

      <div className="report_table_div">
        <Instrument_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Instrument Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Instrument_Report;
